import { useEffect, useRef } from 'react';
import { useAuth } from './auth-provider';

const REVALIDATION_INTERVAL_MS = 15 * 60 * 1000;

export function useSessionGuard(): void {
  const { isSignedIn, supportedFeatures, refreshSession } = useAuth();
  const timerRef = useRef<ReturnType<typeof setInterval> | null>(null);

  const shouldRun = supportedFeatures.requiresSessionGuard && isSignedIn;

  useEffect(() => {
    if (!shouldRun) {
      if (timerRef.current) {
        clearInterval(timerRef.current);
        timerRef.current = null;
      }
      return;
    }

    refreshSession();

    timerRef.current = setInterval(() => {
      refreshSession();
    }, REVALIDATION_INTERVAL_MS);

    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
        timerRef.current = null;
      }
    };
  }, [shouldRun, refreshSession]);
}
